<template>
    <b-modal
        :id="id"
        :title="title"
        centered
        no-close-on-backdrop
        @hidden="close"
    >
        <b-form-textarea
            v-model="message"
            class="mb-2"
            placeholder="Enter something"
            rows="10"
            dir="rtl"
        />

        <div class="form-check">
            <input
                id="type-email"
                v-model="type"
                value="email"
                class="form-check-input"
                type="radio"
            />
            <label class="form-check-label" for="type-email">
                Email
            </label>
        </div>
        <div class="form-check">
            <input
                id="type-sms"
                v-model="type"
                value="sms"
                class="form-check-input"
                type="radio"
            />
            <label class="form-check-label" for="type-sms">
                SMS
            </label>
        </div>

        <template #modal-footer>
            <div class="col-12 d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn-danger waves-effect waves-light mr-2"
                    @click="close"
                >
                    Close
                </button>
                <button
                    type="submit"
                    class="btn btn-success waves-effect waves-light"
                    :disabled="!message"
                    @click="send"
                >
                    Send
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        id: {
            type: String,
            required: false,
            default: 'course-send-message'
        },
        courseId: {
            type: String,
            required: true
        },
        group: {
            type: Object,
            default: () => ({
                text: 'All',
                value: null
            })
        }
    },

    data() {
        return {
            type: 'email',
            message: null
        };
    },

    computed: {
        title() {
            return `Send message to ${this.group.text || 'ALL'} users`;
        }
    },

    methods: {
        ...mapActions({
            sendMessage: 'courses/sendMessage'
        }),

        async send() {
            try {
                await this.sendMessage({
                    type: this.type,
                    id: this.courseId,
                    message: this.message,
                    status: this.group.value
                });

                this.$toaster('Message sent!');
                this.close();
            } catch (error) {
                console.error(error);

                this.$toasterError('Message could not be sent');
            }
        },

        close() {
            this.message = null;
            this.$bvModal.hide(this.id);
        }
    }
};
</script>
